import React from 'react';
import { EditPanel, EditPanelButtons, EditPanelCell, EditPanelRow, PanelBody, PanelHeader, Tray } from '../../../components/elements';
import { ISurveyTemplateElementGroupData } from '../../../components/Surveys/ISurveyTemplateElementGroupData';
import { ISurveyTemplateManifestationData } from '../../../components/Surveys/ISurveyTemplateManifestationData';
import { ISurveyTemplateUnitData } from '../../../components/Surveys/ISurveyTemplateUnitData';
import { getOpenApiRouteItemUrlValidatingElements } from '../../../components/validatingComponents/getOpenApiRouteItemUrlValidatingElements';
import { ValidatingEditPanelSaveButton } from '../../../components/validatingElements';
import { labelSelectOptions } from '../common/labelSelectOptions';

const validatingElements = getOpenApiRouteItemUrlValidatingElements('/api/surveys/{surveyId}/inspectionStandardData/droneLabel', 'post');

export function SurveyEditDroneLabelResult(
    props: { surveyId: string; objectId: string; onItemChanged: () => Promise<void> } & (
        | ISurveyTemplateUnitData
        | ISurveyTemplateElementGroupData
        | ISurveyTemplateManifestationData
    ),
) {
    return (
        <Tray>
            <EditPanel bottomMargin={true} noPadding={true}>
                <PanelBody isForm={true}>
                    <validatingElements.ItemUrlForm
                        onSubmitted={props.onItemChanged}
                        routeParams={{
                            surveyId: props.surveyId,
                        }}
                    >
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={12}>
                                <validatingElements.InputText name="naam" topLabel="Naam" />
                            </EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={12}>
                                <validatingElements.InputText name="locatie" topLabel="Locatie" />
                            </EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={12}>
                                <validatingElements.TextArea name="omschrijving" topLabel="Omschrijving" />
                            </EditPanelCell>
                        </EditPanelRow>

                        <PanelHeader text="Score" fixWidth={true} />

                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={5}>
                                <strong>Reguliere inspectie</strong>
                            </EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={5}>
                                <strong>Drone inspectie</strong>
                            </EditPanelCell>
                        </EditPanelRow>

                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={5}>Kosten</EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={5}>Kosten</EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="reguliereInspectieKostenDroneLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.InputNumber name="reguliereInspectieKosten" />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="droneInspectieKostenDroneLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.InputNumber name="droneInspectieKosten" />{' '}
                            </EditPanelCell>
                        </EditPanelRow>

                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={5}>Veiligheidsrisicoscore voor de inspecteur</EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={5}>Veiligheidsrisicoscore voor de inspecteur</EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="reguliereInspectieVeiligheidsrisicoscoreVoorDeInspecteurDroneLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.InputNumber name="reguliereInspectieVeiligheidsrisicoscoreVoorDeInspecteurScore" />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="droneInspectieVeiligheidsrisicoscoreVoorDeInspecteurDroneLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.InputNumber name="droneInspectieVeiligheidsrisicoscoreVoorDeInspecteurScore" />{' '}
                            </EditPanelCell>
                        </EditPanelRow>

                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={5}>Veiligheidsrisicoscore van de (vaar) weggebruiker</EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={5}>Veiligheidsrisicoscore van de (vaar) weggebruiker</EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="reguliereInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerDroneLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.InputNumber name="reguliereInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerScore" />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="droneInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerDroneLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.InputNumber name="droneInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerScore" />{' '}
                            </EditPanelCell>
                        </EditPanelRow>

                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={5}>Veiligheidsrisicoscore van het luchtvaartverkeer</EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={5}>Veiligheidsrisicoscore van het luchtvaartverkeer</EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="reguliereInspectieVeiligheidsrisicoscoreVanHetLuchtvaartverkeerDroneLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.InputNumber name="reguliereInspectieVeiligheidsrisicoscoreVanHetLuchtvaartverkeerScore" />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="droneInspectieVeiligheidsrisicoscoreVanHetLuchtvaartverkeerDroneLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.InputNumber name="droneInspectieVeiligheidsrisicoscoreVanHetLuchtvaartverkeerScore" />{' '}
                            </EditPanelCell>
                        </EditPanelRow>

                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={5}>Veiligheidsrisicoscore van het object</EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={5}>Veiligheidsrisicoscore van het object</EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="reguliereInspectieVeiligheidsrisicoscoreVanHetObjectDroneLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.InputNumber name="reguliereInspectieVeiligheidsrisicoscoreVanHetObjectScore" />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="droneInspectieVeiligheidsrisicoscoreVanHetObjectDroneLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.InputNumber name="droneInspectieVeiligheidsrisicoscoreVanHetObjectScore" />{' '}
                            </EditPanelCell>
                        </EditPanelRow>

                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={5}>De hinder voor het wegverkeer (Klasse, Categorie)</EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={5}>De hinder voor het wegverkeer (Klasse, Categorie)</EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="reguliereInspectieDeHinderVoorHetWegverkeerDroneLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="reguliereInspectieDeHinderVoorHetWegverkeerKlasse"
                                    selectOptions={labelSelectOptions.hinderKlasse}
                                />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="droneInspectieDeHinderVoorHetWegverkeerDroneLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="droneInspectieDeHinderVoorHetWegverkeerKlasse"
                                    selectOptions={labelSelectOptions.hinderKlasse}
                                />{' '}
                            </EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={3}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="reguliereInspectieDeHinderVoorHetWegverkeerCategorie"
                                    selectOptions={labelSelectOptions.hinderCategorie}
                                />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={4}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="droneInspectieDeHinderVoorHetWegverkeerCategorie"
                                    selectOptions={labelSelectOptions.hinderCategorie}
                                />{' '}
                            </EditPanelCell>
                        </EditPanelRow>

                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={5}>Milieu</EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={5}>Milieu</EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="reguliereInspectieMilieuDroneLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />
                            </EditPanelCell>
                            <EditPanelCell rowCount={3}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="droneInspectieMilieuDroneLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />{' '}
                            </EditPanelCell>
                        </EditPanelRow>

                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={5}>Overall score</EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={5}>Overall score</EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="reguliereInspectieOverallDroneLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />
                            </EditPanelCell>
                            <EditPanelCell rowCount={3}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="droneInspectieOverallDroneLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />{' '}
                            </EditPanelCell>
                        </EditPanelRow>

                        <EditPanelButtons>
                            <ValidatingEditPanelSaveButton small={true} />
                        </EditPanelButtons>
                    </validatingElements.ItemUrlForm>
                </PanelBody>
            </EditPanel>
        </Tray>
    );
}
